export function getKeyValueOfAttributesFromElement(el: HTMLElement): {
  [key: string]: string;
} {
  return Object.entries(el.attributes).reduce(
    (acc, [, attribute]) => ({
      ...acc,
      [attribute.nodeName]: attribute.value,
    }),
    {},
  );
}
